import { SelectOption } from 'src/app/@shared/interfaces/select-option.interface';

export enum eSearchStationsOptions {
  STATION,
  POI,
}

export const SEARCH_STATIONS_OPTIONS: SelectOption<eSearchStationsOptions>[] = [
  {
    label: 'פרטי תחנה',
    value: eSearchStationsOptions.STATION,
  },
  {
    label: 'נקודות עניין',
    value: eSearchStationsOptions.POI,
  },
];
